import React from "react"
import Layout from "../components/layout"
import * as indexCss from "./modules/index.module.scss"
import { graphql, useStaticQuery, Link } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import couverture from "../images/couverture-livre.jpg"

const IndexPage = () => {
  const datas = useStaticQuery(graphql`
    query {
      allContentfulAccueil {
        edges {
          node {
            titre
            sousTitre
            texteDintroduction {
              raw
            }
            titreProchainement
            texteProchainement
            lienProchainement
            quelquesArtistes
            imageCollection {
              file {
                url
              }
              title
            }
          }
        }
      }
    }
  `)
  const data = datas.allContentfulAccueil.edges[0].node
  const content = JSON.parse(data.texteDintroduction.raw)

  return (
    <Layout>
      <section className={indexCss.banner}>
        <div className={indexCss.container}>
          <div className={indexCss.content}>
            <h1>{data.titre}</h1>
            <h2>{data.sousTitre}</h2>
            <div>{documentToReactComponents(content)}</div>
          </div>

          <div className={indexCss.hero}></div>
        </div>
      </section>
      <section className={indexCss.book}>
        <div className={indexCss.image}>
          <img src={couverture} alt="couverture du livre Alfred Grevin" />
        </div>
        <div>
          <div className={indexCss.heading}>
            <span>DISPONIBLE</span>
            <h2>Le livre sur l'œuvre d'Alfred Grevin est disponible</h2>
          </div>
          <p>
            120 pages richement illustrées pour découvrir Alfred Grévin
            (1827-1892), ses dessins humoristiques, ses costumes de théâtre, ses
            illustrations, ses statuettes et ses créations pour le Musée Grévin.
          </p>
          <p className={indexCss.bookPrice}>
            Édition normale : <strong>22 €</strong>
          </p>
          <Link to="/livre">
            <span>
              Découvrir le livre
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                ></path>
              </svg>
            </span>
          </Link>
        </div>
      </section>
      <div className={indexCss.allBooksLink}>
        <Link to="/livres">
          <span>Voir tous les livres</span>
          <span className={indexCss.allBooksIcon} aria-hidden="true">
            ↗
          </span>
        </Link>
      </div>
      {/*
      <Link to={data.lienProchainement}>
        <section className={indexCss.tocome}>
          <p className={indexCss.tocomeTitle}> {data.titreProchainement} </p>
          <p className={indexCss.tocomeText}> {data.texteProchainement} </p>
        </section>
      </Link>
        */}
      <section className={indexCss.collectionContainer}>
        <h3>{data.quelquesArtistes}</h3>
        <div className={indexCss.collection}>
          {data.imageCollection.map(image => {
            return (
              <div className={indexCss.imageContainer} key={image.title}>
                <a href={image.file.url} target="_blank" rel="noreferrer">
                  <img
                    src={image.file.url}
                    alt={image.title}
                    className={indexCss.image}
                  />
                </a>
                <p className={indexCss.caption}>{image.title}</p>
              </div>
            )
          })}
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
